module.exports = __webpack_public_path__ + "static/media/pgs.a9b45d14.jpeg";